import { useState } from "react";

import { Button } from "@icg360/design-system";

import { usePolicyFeature } from "utils/policy-feature-map";

import { SageSureOneModal } from "./modal";
import styles from "./ss1.module.scss";

export const SageSureOneBanner = () => {
  const show = usePolicyFeature("sageSureOneDisplay");
  const [openModal, setOpenModal] = useState(false);
  if (!show) return null;
  return (
    <>
      <div className={styles.banner}>
        <div className={styles.content}>
          <img
            className={styles.logo}
            src="/assets/images/ss1-one.svg"
            alt="SageSure One"
          />
          <p className="body-sm-regular">
            Your policy includes the SageSure One experience.{" "}
            <Button
              appearance="link"
              size="xs"
              onPress={() => setOpenModal(true)}
            >
              Explore the benefits
            </Button>
          </p>
        </div>
      </div>
      <SageSureOneModal open={openModal} onClose={() => setOpenModal(false)} />
    </>
  );
};
